const variants = {
  INBOUND: 'INBOUND',
  OUTBOUND: 'OUTBOUND',
  SYSTEM: 'SYSTEM',
};

const getMessageVariant = (message, chatUser) => {
  if (message.isSystem) {
    return variants.SYSTEM;
  }
  if (message.userId === chatUser.id) {
    return variants.OUTBOUND;
  }
  return variants.INBOUND;
};

export default variants;
export { getMessageVariant };
